import { alertError, alertSuccess } from './alert';
import { putSupplierRetailer } from './api/suppliers';

export const updateSupplierRetailer =
  ({
    supplierId,
    retailerId,
    data,
    updateSuccessToastMessage = 'Update Success',
    updateFailureToastMessage = 'Error updating',
  }) =>
  async (dispatch) => {
    try {
      const response = await putSupplierRetailer({ supplierId, retailerId, data });
      if (response.data.success) {
        dispatch(alertSuccess(updateSuccessToastMessage));
      } else {
        dispatch(alertError(updateFailureToastMessage));
      }
    } catch (error) {
      dispatch(alertError(error));
    }
  };
